import React, { useState, useEffect } from "react"
import { Button, Grid, InputAdornment, TextField, Paper, Tooltip, FormControl, Box, IconButton, makeStyles } from "@material-ui/core"
import { DateRangePicker } from "materialui-daterange-picker"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import ExpandLessIcon from "@material-ui/icons/ExpandLess"
import moment from "moment"
import "./DateRangeStyle.css"
import { DATE_FORMAT } from "../../../utils"
import { KeyboardArrowDown } from "@material-ui/icons"

const useStyles = makeStyles((theme) => ({
	boxWrapper: {
		maxWidth: 150,
		minWidth: 150,
		margin: "0 10px",
		height: "100%",
		minHeight: 48,
		maxHeight: 48,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
	},
	select: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.text.primary,
		},
		"& .MuiSelect-root": {
			...theme.typography.body1,
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
			border: "transparent",
		},
	},
	dateRangePickerOpenArrow: {
		"&.Mui-disabled": {
			opacity: "0.5",
		},
	},
	dateRangeSelected: {
		width: 290,
		maxWidth: 290,
	},
}))

const DateRange = ({
	handleDateRangeChange,
	selectedDateRange = { startDate: "", endDate: "" },
	dateRange = { startDate: "", endDate: "" },
	setDateRange = () => {},
	disableFilters,
}) => {
	const classes = useStyles()

	const initialDateRange = selectedDateRange
	const [open, setOpen] = useState(false)

	const toggle = () => setOpen(!open)

	const applyDateRange = () => {
		toggle()
		const dateString = `${moment(dateRange.startDate).format(DATE_FORMAT)} - ${moment(dateRange.endDate).format(DATE_FORMAT)}`
		handleDateRangeChange(dateRange)
	}

	const clearDate = () => {
		toggle()
		setDateRange(initialDateRange)
		handleDateRangeChange(initialDateRange)
	}

	return (
		<Box className={`${classes.boxWrapper} ${dateRange?.startDate && dateRange?.endDate ? classes.dateRangeSelected : ""}`}>
			<FormControl fullWidth size="small">
				<Tooltip
					placement="top"
					arrow
					title={
						dateRange?.startDate && dateRange?.endDate
							? `${moment(dateRange.startDate).format(DATE_FORMAT)} - ${moment(dateRange.endDate).format(DATE_FORMAT)}`
							: ""
					}
				>
					<TextField
						size="small"
						id="outlined-select-currency"
						label="Date Range"
						value={
							dateRange?.startDate && dateRange?.endDate
								? `${moment(dateRange.startDate).format(DATE_FORMAT)} - ${moment(dateRange.endDate).format(DATE_FORMAT)}`
								: ""
						}
						variant="outlined"
						onFocus={toggle}
						disabled={disableFilters}
						className={classes.select}
						InputLabelProps={{ style: { fontWeight: 400 } }}
						InputProps={{
							readOnly: true,
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={toggle}
										style={{
											padding: "0px",
											top: 2,
										}}
										className={classes.dateRangePickerOpenArrow}
										disabled={disableFilters}
									>
										{open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
				</Tooltip>
				{open && (
					<Paper
						style={{
							color: "text.secondary",
							position: "absolute",
							top: "50px",
							zIndex: 2,
						}}
					>
						<div className="date-range-picker-container">
							<DateRangePicker
								initialDateRange={dateRange}
								open={open}
								toggle={toggle}
								onChange={(range) => setDateRange(range)}
								definedRanges={[]}
								wrapperClassName="date-range-picker-wrapper"
								maxDate={new Date()}
								minDate={moment("01/01/1990").format("DD MM YYYY")}
							/>

							<Box
								p={1}
								style={{
									zIndex: 2,
									bottom: 10,
									right: 16,
								}}
							>
								<Grid container style={{ justifyContent: "end", marginTop: "16px" }}>
									<Button variant="contained" onClick={clearDate} style={{ color: "text.disabled", marginRight: 12 }}>
										Clear
									</Button>
									<Button
										variant="contained"
										color="primary"
										onClick={applyDateRange}
										disabled={!dateRange?.startDate || !dateRange?.endDate}
									>
										Apply
									</Button>
								</Grid>
							</Box>
						</div>
					</Paper>
				)}
			</FormControl>
		</Box>
	)
}

export default DateRange
